"use strict";
exports.__esModule = true;
exports.getChainAPI = void 0;
var spl_token_1 = require("@solana/spl-token");
var web3_js_1 = require("@solana/web3.js");
function getChainAPI(config, logger) {
    var fetchMiddleware = logger === undefined
        ? undefined
        : function (url, options, fetch) {
            logger(url, options);
            fetch(url, options);
        };
    var connection = function () {
        return new web3_js_1.Connection(config.endpoint, {
            commitment: "finalized",
            fetchMiddleware: fetchMiddleware
        });
    };
    return {
        getBalance: function (address) {
            return connection().getBalance(new web3_js_1.PublicKey(address));
        },
        getRecentBlockhash: function () {
            return connection()
                .getRecentBlockhash()
                .then(function (r) { return r.blockhash; });
        },
        getTxFeeCalculator: function () {
            return connection()
                .getRecentBlockhash()
                .then(function (r) { return r.feeCalculator; });
        },
        getBalanceAndContext: function (address) {
            return connection().getBalanceAndContext(new web3_js_1.PublicKey(address));
        },
        getParsedTokenAccountsByOwner: function (address) {
            return connection().getParsedTokenAccountsByOwner(new web3_js_1.PublicKey(address), {
                programId: spl_token_1.TOKEN_PROGRAM_ID
            });
        },
        getStakeAccountsByStakeAuth: function (authAddr) {
            return connection().getParsedProgramAccounts(web3_js_1.StakeProgram.programId, {
                filters: [
                    {
                        memcmp: {
                            offset: 12,
                            bytes: authAddr
                        }
                    },
                ]
            });
        },
        getStakeAccountsByWithdrawAuth: function (authAddr) {
            return connection().getParsedProgramAccounts(web3_js_1.StakeProgram.programId, {
                filters: [
                    {
                        memcmp: {
                            offset: 44,
                            bytes: authAddr
                        }
                    },
                ]
            });
        },
        getStakeActivation: function (stakeAccAddr) {
            return connection().getStakeActivation(new web3_js_1.PublicKey(stakeAccAddr));
        },
        getInflationReward: function (addresses) {
            return connection().getInflationReward(addresses.map(function (addr) { return new web3_js_1.PublicKey(addr); }));
        },
        getVoteAccounts: function () { return connection().getVoteAccounts(); },
        getSignaturesForAddress: function (address, opts) { return connection().getSignaturesForAddress(new web3_js_1.PublicKey(address), opts); },
        getParsedConfirmedTransactions: function (signatures) {
            return connection().getParsedConfirmedTransactions(signatures);
        },
        getAccountInfo: function (address) {
            return connection()
                .getParsedAccountInfo(new web3_js_1.PublicKey(address))
                .then(function (r) { return r.value; });
        },
        sendRawTransaction: function (buffer) {
            return (0, web3_js_1.sendAndConfirmRawTransaction)(connection(), buffer, {
                commitment: "confirmed"
            });
        },
        findAssocTokenAccAddress: function (owner, mint) {
            return spl_token_1.Token.getAssociatedTokenAddress(spl_token_1.ASSOCIATED_TOKEN_PROGRAM_ID, spl_token_1.TOKEN_PROGRAM_ID, new web3_js_1.PublicKey(mint), new web3_js_1.PublicKey(owner)).then(function (r) { return r.toBase58(); });
        },
        getAssocTokenAccMinNativeBalance: function () {
            return spl_token_1.Token.getMinBalanceRentForExemptAccount(connection());
        },
        getMinimumBalanceForRentExemption: function (dataLength) {
            return connection().getMinimumBalanceForRentExemption(dataLength);
        },
        getEpochInfo: function () { return connection().getEpochInfo(); },
        config: config
    };
}
exports.getChainAPI = getChainAPI;
//# sourceMappingURL=index.js.map